import type { BestNextMoveBundle } from '../contracts/types'

export const BNM_VISITOR: BestNextMoveBundle = {
  generatedAt: '2026-05-31T00:00:00.000Z',
  primary: {
    recommendationId: 'bnm-visitor-access-01',
    category: 'request_access',
    title: 'Request Access to begin your creator pathway',
    summary:
      'SynkTribe is in controlled access. Request Access to start the review process for Guided Studio pathways.',
    whyThisMatters:
      'Access is granted deliberately so the Command Deck and tools reflect what is actually available to you.',
    riskIfIgnored:
      'You will remain on preview pathways without project build surfaces.',
    suggestedSurface: 'request_access',
    suggestedAction: 'Request Access',
    affectedProjectId: 'none',
    priority: 'critical',
    confidence: 'high',
    humanConfirmationRequired: false,
    allowedActions: ['start', 'defer', 'dismiss'],
    forbiddenActions: [
      'sign_in',
      'create_account',
      'launch_app',
      'auto_execute',
      'auto_publish',
      'auto_handoff',
    ],
    toolAvailabilityRequired: 'request_access',
    blockersAddressed: [],
  },
  secondary: [
    {
      recommendationId: 'bnm-visitor-demo-01',
      category: 'book_demo',
      title: 'Book a guided demo',
      summary:
        'See how SynkTribe moves from intent to structure, timeline, presentation, and world layers — with honest boundaries.',
      whyThisMatters:
        'A demo clarifies what is live today versus on the roadmap.',
      riskIfIgnored: 'You may miss a faster path to studio or investor conversations.',
      suggestedSurface: 'book_demo',
      suggestedAction: 'Book Demo',
      affectedProjectId: 'none',
      priority: 'medium',
      confidence: 'high',
      humanConfirmationRequired: false,
      allowedActions: ['start', 'defer', 'dismiss'],
      forbiddenActions: ['sign_in', 'create_account', 'launch_app'],
      toolAvailabilityRequired: 'book_demo',
      blockersAddressed: [],
    },
  ],
}
